import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import {combineReducers} from 'redux';

import global from './global/reducer';
import app from './app/reducer';
import auth from './auth/reducer';
import articles from './articles/reducer';

const rootReducer = combineReducers({
	global,
	app,
	auth,
	articles,
});

let store;
if (process.env.NODE_ENV === 'production') {
	store = createStore(rootReducer, applyMiddleware(thunk));
} else {
	store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk, logger)));
}

export default store;
